var version = {
    "name":      "dativery",
    "buildDateCode": "20261014-175654",
    "buildDate": "Wed Oct 14 2026 17:56:54 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261014-175654",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;